// Timeline.js
import React from 'react';
import { View, Text, FlatList, TouchableOpacity } from 'react-native';
import { ScaledSheet } from '@utils/scale';

export default function Timeline({
  data = [],
  lineColor = '#4caf50',
  iconSize = 44,
  onItemPress = () => { },
  containerStyle,
}) {
  const leftWidth = Math.max(72, iconSize + 24);

  const renderItem = ({ item, index }) => {
    const isLast = index === data.length - 1;
    const Icon = item.Icon;

    return (
      <View style={[styles.row, { paddingHorizontal: 16 }]}>
        {/* LEFT: icon circle + vertical line */}
        <View style={[styles.leftCol, { width: leftWidth }]}>
          <View style={styles.iconStack}>
              {Icon ? (
                <Icon />
              ) : (
                <View style={styles.emptyDot} />
              )}
          </View>

          {/* The vertical connector line */}
          {!isLast && (
            <View
              style={[
                styles.verticalLine,
                {
                  backgroundColor: lineColor,
                  left: leftWidth / 2 - 1, // center under icon
                  top: iconSize / 2 + 8, // Start from the middle of the icon
                  bottom: -8, // Extend slightly into the next item
                  height: '100%', // Will be overridden by bottom
                },
              ]}
            />
          )}
        </View>

        {/* RIGHT: content */}
        <TouchableOpacity
          activeOpacity={0.85}
          onPress={() => onItemPress(item)}
          style={styles.rightCol}
        >
          <Text style={styles.title}>{item.title}</Text>
          {item.subtitle ? <Text style={styles.subtitle}>{item.subtitle}</Text> : null}
          {item.description ? <Text style={styles.description}>{item.description}</Text> : null}
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <View style={[{ paddingVertical: 18 }, containerStyle]}>
      {data.map((item, index) => (
        <View key={item.id != null ? String(item.id) : index}>
          {renderItem({ item, index })}
          {index < data.length - 1 && <View style={{ height: 18 }} />}
        </View>
      ))}
    </View>
  );
}

const styles = ScaledSheet.create({
  row: { 
    flexDirection: 'row', 
    alignItems: 'flex-start',
    position: 'relative',
  },
  leftCol: { 
    alignItems: 'center', 
    position: 'relative',
    paddingBottom: 8, // Reduce spacing between items
    justifyContent: 'flex-start',
  },
  iconStack: {
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  iconCircle: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 0,
    // shadow for iOS
    shadowColor: '#000',
    shadowOpacity: 0.06,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 1 },
    // elevation for Android
    elevation: 2,
  },
  emptyDot: { width: 10, height: 10, borderRadius: 5, backgroundColor: '#ccc' },
  verticalLine: {
    position: 'absolute',
    width: 2,
    top: 0, // Will be overridden by inline styles
    bottom: 0, // Will be overridden by inline styles
    height: 'auto',
  },
  rightCol: {
    flex: 1,
    paddingLeft: 12,
    paddingRight: 8,
  },
  title: { fontSize: 16, color: '#1f2937', fontWeight: '400' },
  subtitle: { marginTop: 4, color: '#475569' },
  description: { marginTop: 8, color: '#6b7280', fontSize: 12 },
});
